import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';

@Injectable()

export class DepartmentEndpoint extends EndpointFactory {
  private readonly submitDepartmentEndpointPath: string = "/api/departmentItemService/submitDepartment";
  private readonly submitLegislationEndpointPath: string = "/api/departmentItemService/submitLegislation";
  private readonly moveLegislationEndpointPath: string = "/api/departmentItemService/moveLegislation";

  private readonly submitAgencyEndpointPath: string = "/api/departmentItemService/submitAgency";
  private readonly getAllDepartmentsEndpointPath: string = "/api/departmentItemService/getAllDepartments";
  private readonly moveAgencyEndpointPath: string = "/api/departmentItemService/moveAgency";

  get submitDepartmentEndpointUrl() { return this.configurations.baseUrl + this.submitDepartmentEndpointPath; }
  get submitLegislationEndpointUrl() { return this.configurations.baseUrl + this.submitLegislationEndpointPath; }
  get moveLegislationEndpointUrl() { return this.configurations.baseUrl + this.moveLegislationEndpointPath; }
  get moveAgencyEndpointUrl() { return this.configurations.baseUrl + this.moveAgencyEndpointPath; }
  get submitAgencyEndpointUrl() { return this.configurations.baseUrl + this.submitAgencyEndpointPath; }

  get getAllDepartmentsEndpointUrl() { return this.configurations.baseUrl + this.getAllDepartmentsEndpointPath; }


  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getAllDepartments<T>(): Observable<T> {
    let endpointUrl = `${this.getAllDepartmentsEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  submitDepartment<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitDepartmentEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  submitLegislation<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitLegislationEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  moveLegislation<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.moveLegislationEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  submitAgency<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitAgencyEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  moveAgency<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.moveAgencyEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }
}
